<template>
	<div class="m-auto">
		<jet-validation-errors class="mx-auto mb-4 text-center" />
	</div>
	<div class="w-full rounded-lg bg-blue-300">
		<form @submit.prevent="submit" class="m-auto">
			<button
				type="submit"
				class="mx-auto w-full rounded-lg py-4 px-2 font-bold text-gray-900 md:w-1/2 md:p-4"
			>
				<!-- {{ //action.toUpperCase() }} -->
				{{ action }}
			</button>
		</form>
	</div>
</template>
<script>
import { useForm } from "@inertiajs/inertia-vue3";
import JetInput from "@/Jetstream/Input";
import JetValidationErrors from "@/Jetstream/ValidationErrors";
export default {
	props: {
		orderId: String,
		action: String,
	},
	setup(props) {
		const form = useForm({
			orderId: props.orderId,
			action: props.action,
		});
		// this.$inertia.post(route('candidacy.store'), data);
		function submit() {
			console.log(this.form.action);
			// form.post("/dsv/sensdd");
		}

		return { form, submit };
	},
	components: {
		JetValidationErrors,
		JetInput,
	},
};
</script>
